import React, { Component, Fragment } from 'react';
import api from '../../../services/api';
import ModalConfirm from '../../common/modal-confirm';
import ModalAlert from '../../common/modal-alert';
import Pagination from '../../../components/Common/pagination';
class Permission extends Component {

    state = {
        load: false,
        functions: {},
        erroDelete: false,
        insertFunction: false,
        msgError: null,
        msgSuccess: null,
        nameFunction: '',
        idSector: null,
        classText: '',
        paginas:0
    }

    componentDidMount() {
        this.searchFunctions();
    }

    searchFunctions = async (e) => {
        let page = (e)?e.target.id:1;
        this.setState({ load: true });
        const response = await api.get(`/functions?order_by=id&order_direction=DESC&page=${page}`);
        this.setState({ functions: response.data.rows, load: false, paginas:Math.ceil(response.data.count/10) });
    }

    insertFunction = () => {
        document.getElementById('nameFunction').value = '';
        this.setState({ 
            insertFunction: true, 
            msgError: null, 
            msgSuccess:null 
        });
    }

    createFunction = async () => {
        let nameFunction = document.getElementById('nameFunction').value;

        try {

            let response = await api.post(`/functions`, { description: nameFunction });
            this.searchFunctions();
            document.getElementById('nameFunction').value = '';
            this.setState({ msgError: null, msgSuccess: response.data.msg });

        } catch (err) {
            this.setState({ msgError: err.response.data.errors[0].msg, msgSuccess: null });
        }
    }

    updateStatus = async (e) => {
        const id = e.target.id;
        const value = (e.target.name == 1) ? 0 : 1;
        document.getElementById("modal-alert").click();
        try {
            const response = await api.put(`/functions/${id}`, { status: value });
            this.searchFunctions();
            this.setState({ msgAlert: response.data.msg, classText: "text-success" });
        } catch (err) {
            this.setState({ msgAlert: err.response.data.errors[0].msg, classText: "text-danger" });
        }
    }

    alterFunction = (e) => {
        const id = e.target.id;
        const sector = this.state.functions.filter((item) => (item.id == id));
        document.getElementById("nameFunction").value = sector[0].description;

        this.setState({
            msgError: null,
            msgSuccess: null,
            idSector: id,
            nameFunction: sector[0].description
        });
    }

    confirmAlterFunction = async (e) => {
        let nameFunction = document.getElementById('nameFunction').value;
        try {

            let response = await api.put(`/functions/${this.state.idSector}`, { description: nameFunction });
            this.searchFunctions();
            this.setState({ msgError: null, msgError: null, msgSuccess: response.data.msg });

        } catch (err) {
            this.setState({ msgError: err.response.data.errors[0].msg, msgSuccess: null });
        }
    }

    deleteFunction = async (e) => {
        const id = e.target.id;
        if (id) {
            this.setState({ idSector: id, erroDelete: null });
            document.getElementById("modal-confirm").click();
        }
    }

    confirmDeleteFunction = async () => {
        this.setState({ load: true });
        try {
            const response = await api.delete(`/functions/${this.state.idSector}`);
            this.searchFunctions();
            this.setState({ load: false, idSector: null, erroDelete: null });
            document.getElementById('close-modal-confirm').click();

            document.getElementById("modal-alert").click();
            this.setState({ msgAlert: response.data.msg, classText: "text-success" });

        } catch (err) {
            let msg = (err.response.data.errors) ? err.response.data.errors[0].msg : err.response.data.msg;
            this.setState({ erroDelete: msg });
        };
    }

    render() {
        return (
            <Fragment>
                <div className="row page-titles">
                    <div className="col-md-5 col-8 align-self-center">
                        <h3 className="text-themecolor">Funções
                        {(this.state.load) ? <i className="fa fa-spin fa-spinner"></i> : null}
                        </h3>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">

                            <div className="p-20 text-right">
                                <div className="col-md-2 btn btn-rounded btn-primary" data-toggle="modal" data-target=".modal-alter-document" onClick={this.insertFunction}>Cadastrar</div>
                            </div>

                            <table className="table table-bodered">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Função</th>
                                        <th>Ativo</th>
                                        <th>Editar</th>
                                        <th>Excluir</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {(this.state.functions.length) ?
                                        (this.state.functions).map((item) => {
                                            return (
                                                <tr key={item.id}>
                                                    <td>{item.id}</td>
                                                    <td>{item.description}</td>
                                                    <td className="td-button" id={item.id}>
                                                        <div className="switch">
                                                            <label>
                                                                <input type="checkbox" defaultChecked={item.status} id={item.id} name={item.status} onChange={this.updateStatus} /><span className="lever"></span>
                                                            </label>
                                                        </div>
                                                    </td>
                                                    <td className="td-button">
                                                        <button type="button" id={item.id} onClick={this.alterFunction} data-toggle="modal" data-target=".modal-alter-document" className="btn btn-sm btn-outline-success btn-circle">
                                                            <i id={item.id} className="fa fa-edit"></i>
                                                        </button>
                                                    </td>
                                                    <td className="td-button">
                                                        <button type="button" id={item.id} onClick={this.deleteFunction} className="btn btn-sm btn-outline-danger btn-circle">
                                                            <i id={item.id} className="fa fa-times"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            )
                                        })
                                        : null}
                                </tbody>
                            </table>

                            <Pagination function={this.searchFunctions} paginas={this.state.paginas} />
                        </div>
                    </div>
                </div>

                <ModalConfirm title="Confirmação" msg="Tem certeza que deseja excluir a função?" function={this.confirmDeleteFunction} msgError={this.state.erroDelete} />
                <ModalAlert title="Informação" msg={this.state.msgAlert} function="" classText={this.state.classText} />

                <div className="modal fade modal-alter-document" data-backdrop="static" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="myLargeModalLabel">
                                    {(this.state.insertFunction) ? 'Cadastrar ' : 'Alterar '}
                                    Função
                                {(this.state.load) ? <i className="fa fa-spin fa-spinner"></i> : null}
                                </h5>
                                <button type="button" className="close" data-dismiss="modal" aria-hidden="true">×</button>
                            </div>
                            <div className="modal-body">
                                <form>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <span>Função <i className="text-danger">*</i></span>
                                            <input type="text" id="nameFunction" className="form-control" defaultValue={this.state.nameSector}></input>
                                        </div>
                                        {(this.state.msgError || this.state.msgSuccess) ?
                                            <div className="col-md-12 p-t-20">
                                                <div className={(this.state.msgSuccess) ? 'alert alert-success' : 'alert alert-danger'}>
                                                    {this.state.msgError}
                                                    {this.state.msgSuccess}
                                                </div>
                                            </div>
                                            : null}

                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer">
                                {(this.state.insertFunction) ?
                                    <button className="col-md-2 btn waves-effect waves-light btn-rounded btn-success" onClick={this.createFunction}>
                                        Cadastrar
                            </button>
                                    :
                                    <button className="col-md-2 btn waves-effect waves-light btn-rounded btn-success" onClick={this.confirmAlterFunction}>
                                        Alterar
                                </button>
                                }

                                <button type="button" id="closeModalCreate" className="col-md-2 btn btn-secondary btn-rounded waves-effect" data-dismiss="modal">Fechar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment >
        )
    }

}

export default Permission;